import { render, staticRenderFns } from "./BoardMeeting.vue?vue&type=template&id=46228ae4&"
import script from "./BoardMeeting.vue?vue&type=script&lang=js&"
export * from "./BoardMeeting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports